import { Component, OnInit } from '@angular/core';
import { ItemMenuLateral } from 'app/angular-base-ui/menu-lateral/item-menu-lateral.model';
import { PortalService } from 'app/area-cliente/portal/portal.service';

@Component({
  selector: 'layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})

export class LayoutComponent implements OnInit {

  constructor(private servicePortal: PortalService) { }


  ngOnInit() {
    
    this.itensMenuLateral.push(new ItemMenuLateral("Base de conhecimento", "/suporte", "zmdi zmdi-thumb-up"));
    if(this.servicePortal.isHabilitaSuporte()){
      this.itensMenuLateral.push(new ItemMenuLateral("Central de ajuda", "/ajuda", "zmdi zmdi-help"));
    }
    this.itensMenuLateral.push(new ItemMenuLateral("Boletos", "/boleto", "zmdi zmdi-print"));
    this.itensMenuLateral.push(new ItemMenuLateral("Blog unifar", "/noticias", "zmdi zmdi-receipt"));
  }

  // menu lateral
  isCollapsed: boolean = true;
  private dados;
  fantasia;

  atualizaDadosCliente(dados) {
    this.dados = dados;
    this.fantasia = this.dados.fantasia;
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
  }

  // menus da barra lateral
  itensMenuLateral: Array<ItemMenuLateral> = [
  ];
}


// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/layout/layout/layout.component.ts